import './scripts/common';

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

import * as floatingLabels from '@elements/floating-labels';
floatingLabels.init();

import * as azTeaserSlider from './scripts/az-teaser-slider';
azTeaserSlider.init();

import * as imgTeaserSlider from './scripts/img-teaser-slider';
imgTeaserSlider.init();

import * as imageSlider from './scripts/image-slider';
imageSlider.init();

import * as ajaxForm from '@elements/ajax-form';
ajaxForm.init();

import * as multiselectDropdown from './scripts/multiselect-dropdown';
multiselectDropdown.init();

import * as dropdownPersist from './scripts/dropdown-persist';
dropdownPersist.init();

import * as scrollTop from './scripts/scroll-top';
scrollTop.init();

import * as googleMap from "./scripts/google-map";
googleMap.init();

import * as wishlist from './scripts/wishlist';
wishlist.init();

import * as scrollToTop from './scripts/scroll-to-top';
scrollToTop.init();

import 'bootstrap/js/dist/dropdown';
import Collapse from 'bootstrap/js/dist/collapse';

import * as setDatepicker from "./scripts/set-datepicker";
setDatepicker.init();

import * as datepickerRange from "@elements/datepicker-range";
datepickerRange.init();



